import React                   from 'react';
import { connect }             from 'react-redux';
import EggBox                  from 'pages/tirgul/inputQuestion/eggBox';
import Button                  from 'components/buttons/DisplayEggBoxButton';
import { reducerType }         from 'reducer';
import { makeStyles }          from "makeStyles";
import sizes                   from 'utils/sizes';
import { componentsStateType } from 'reducer/types';


const hebtext  = "בשלב זה מתאימים מספר לכמות נתונה של ביצים"
const hebText1 = 'לחיצה על כפתור ההרחבה תוביל לפריסת התבניות בחלונית נפרדת'
const hebText2 = "התאמת המספר מתבצעת באמצעות שימוש במקלדת"


const useStyles = makeStyles()(
    (theme) => ({
        root: {
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
          width:           '100%',
        },
        container : {
          display:         'flex',
          alignItems:      'center',
          justifyContent:  'center',
        },
        column : {
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            flexFlow:        'column',
        },
        row : {
         /*    display:         'flex',
           // alignItems:      'center',
            justifyContent:  'space-between',
            flexFlow:        'row', */
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'space-evenly',
            flexFlow:        'row',
            border:          '1px solid #CCC',
            borderRadius:    '0.4em',
        },
        input: {
            width:           '100%',
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            color:           theme.darkBlue,
            fontSize:        75,
            height:          100,
            marginTop:       15,
          //  borderRadius:    '0.5em',
          //  border:          `1px solid ${ theme.darkBlue }`
        },
        input2: {
            width:           '100%',
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            color:           theme.darkBlue,
            fontSize:        22,
            marginTop:       5,
          
        },
        questionText: {
            height:          45,
            width:           250,
            fontSize:        22,
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            borderRadius:    '0.5em',
            color:           theme.darkBlue,
            border:          `1px solid ${ theme.darkBlue }`
        },     
        buttonContainer: {
            position:       'absolute',
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'center',
            width:          50,
            height:         50,
            borderRadius:   '50%',
            transition:     'all 0.3s',
        }
    }),
);

type QuestionPropsType = {
    size:            number[];
    question:        number;
    variant:         string;
    pageNum:         number;
    wideScreen:      boolean;
    componentsState: componentsStateType;
}

const Question: React.FC<QuestionPropsType> = ({
    size,
    componentsState,
    variant,
    pageNum,
    wideScreen,
    question,
}) => {

    const { classes } = useStyles();

     const [num1, num2] = React.useMemo(() => {

        if (!question) {
            return [0,0]
        }
        if ( question < 10 ) {
            return [0, question];
        }
        return [Math.floor(question/10), question%10]
    },[question])
    

    const [rowStyle, buttonStyle] = React.useMemo(() => {

        const { bigBoxHeight, smallBoxHeight, bigBoxWidth, smallBoxWidth ,bigBoxGap, smallBoxGap } = sizes;
   
        const boxHeight = wideScreen ? bigBoxHeight : smallBoxHeight;
        const boxWidth  = wideScreen ? bigBoxWidth : smallBoxWidth;
        const BoxGap    = wideScreen ? bigBoxGap : smallBoxGap;
        const width     = wideScreen ? ((boxWidth * 2) + 30 ) : size[0] * 0.4
        const height    = boxHeight + (num1 * BoxGap);
   
        return[

            {
               height: height,
               width:  width
            },
            {
                border:    `3px solid ${ pageNum === 1 ? '#F00' : 'transparent' }`,
                transform: `translate(${ -width/2 - 35 }px, ${ -height/2 + 15 }px)`,
            }
            
         ]
      },[num1, pageNum, wideScreen, size])
 

   

    return(
        <div className = { classes.root }>
            <div className = { classes.container }>
                {
                    variant === 'input' && 
                    <div className = { classes.column } >
                        <div 
                            className = { classes.row }
                            style     = { rowStyle }
                        >
                            {
                                !!num1 &&
                                <EggBox
                                   value      = { num1 }
                                   variant    = { 'tens' }
                                   wideScreen = { wideScreen }
                                   showClosed
                                />
                            }
                            {
                                !!num2 &&
                                <EggBox
                                    value      = { num2 }
                                    wideScreen = { wideScreen }
                                    showClosed
                                />
                            }
                             <div 
                                className = { classes.buttonContainer }
                                style     = { buttonStyle }
                            >
                                <Button
                                  variant    = { 'mazeget' }
                                  value      = { pageNum - 4 }
                                  wideScreen = { true }
                                />
                           </div>
                    </div>
                    <div className = { classes.input } >
                        { pageNum === 3 ? '3' : pageNum === 4 ? '37' : '' }
                    </div>
                    <div 
                        dir       = 'rtl'
                        className = { classes.input2 }
                 //       style     = {{ opacity: pageNum <=2 ? 1 : 0 }}
                    >
                        { pageNum >= 2 ? hebText2 : [hebtext, hebText1, hebText2][pageNum] }
                    </div>
                    </div>
                }
                {
                    variant === 'dnd' && 
                    <div className = { classes.questionText }>
                       { question } 
                    </div>
                    
                }
            </div>
        </div>
    )
}


  

  const mapStateToProps = (reducer: reducerType) => {
    return {
      componentsState: reducer.components
  }};
  
  export default connect(mapStateToProps)(Question);
  
  
  
  